import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { useUnfollowUserMutation } from "Api/Mutations/Social/useUnfollowUserMutation";
import { useFollowedUsersQuery } from "Api/Queries/Social/useFollowListsQuery";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { SocialSummaryRow } from "Components/Social/SocialSummaryRow";
import { SocialUserActionsMenu } from "Components/Social/SocialUserActionsMenu";
import { SocialListPagination } from "Pages/People/SocialListPagination";
import {
  useSnapBackToLastPage,
  useSocialListPage,
} from "Pages/People/useSocialListPage";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Social.People;

/** A page of the personas the caller follows, with unfollow. */
export const FollowingSection = () => {
  const { t } = useResource();
  const { currentPage, setPage } = useSocialListPage();
  const { data: followed, isLoading } = useFollowedUsersQuery(currentPage);
  useSnapBackToLastPage(followed, currentPage, setPage);
  const { mutate: unfollow, isPending } = useUnfollowUserMutation();

  return (
    <PrimaryPaper>
      <Stack gap={4}>
        {isLoading && (
          <Stack alignItems="center" py={1}>
            <CircularProgress size={24} />
          </Stack>
        )}
        {followed?.totalCount === 0 && (
          <Typography variant="body2" color="text.secondary">
            {t(RESOURCES.NoFollowing)}
          </Typography>
        )}
        {followed?.items.map((user) => (
          <SocialSummaryRow
            key={user.identityUserPublicID}
            user={user}
            action={
              <>
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  disabled={isPending}
                  onClick={() => unfollow(user.identityUserPublicID)}
                >
                  {t(RESOURCES.Unfollow)}
                </Button>
                <SocialUserActionsMenu
                  identityUserPublicID={user.identityUserPublicID}
                  handle={user.handle}
                  displayName={user.displayName}
                  isBlockVisible
                  isDisabled={isPending}
                />
              </>
            }
          />
        ))}
        {followed && (
          <SocialListPagination
            totalCount={followed.totalCount}
            currentPage={currentPage}
            onPageChange={setPage}
          />
        )}
      </Stack>
    </PrimaryPaper>
  );
};
